import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { Link } from 'foundations-components/transitional/components/Link';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import LearnMoreModalListItem from '../base/LearnMoreModalListItem';
import LearnMoreModal from '../base/LearnMoreModal';
import { useModalTracker } from '../../../hooks/tracking';
import { ACADEMY_LESSON_CREATE_FORM_URL, KNOWLEDGE_BASE_CREATE_FORM_URL } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const a = 'https://knowledge.hubspot.com/forms/create-forms';
const AddSupportFormModal = ({
  onClose
}) => {
  const {
    trackLink
  } = useModalTracker('AddSupportFormModal');
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.addSupportForm.heading"
    }),
    illustrationName: "forms",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.addSupportForm.description"
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.addSupportForm.li1"
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.addSupportForm.li2"
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.addSupportForm.li3"
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.addSupportForm.p1"
      })
    }), /*#__PURE__*/_jsx(KnowledgeBaseButton, {
      onClick: () => trackLink('create forms article'),
      url: KNOWLEDGE_BASE_CREATE_FORM_URL,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: ACADEMY_LESSON_CREATE_FORM_URL,
      onClick: () => trackLink('create forms lesson'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.watchVideo"
      })
    })]
  });
};
AddSupportFormModal.propTypes = {
  onClose: PropTypes.func
};
export default AddSupportFormModal;